import { billOfMaterialsIdFormat } from "@redotech/redo-fulfillment-id";
import * as z from "zod";

export const reevaluateBillOfMaterialsOpenOrders = {
  name: "reevaluateBillOfMaterialsOpenOrders" as const,
  input: z.object({ billOfMaterialsId: billOfMaterialsIdFormat.schema }),
  output: z.object({ workflowId: z.string().nullable() }),
};
